import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly, type Env0Theme } from 'constants/themes.constants';
import styled from 'types/theme.types';

const inlineContainer = `
  display: inline-block;
  width: max-content;
  float: right;
`;

const blockContainer = `
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

const FormButtonsContainer = styled.div<{
  withSeparator?: boolean;
  isInline?: boolean;
}>`
  ${({ isInline }) => (isInline ? inlineContainer : blockContainer)};
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: ${({ theme, withSeparator }) => withSeparator && '1px solid ' + theme.lightGray};

  ${legacyOnly(
    theme => css`
      button,
      a {
        width: 210px;
      }

      a {
        border-color: ${theme.primaryBlack};
        margin-left: 20px;
        color: ${theme.primaryBlack};

        &:hover {
          background-color: ${theme.primaryBlack};
          color: ${theme.primaryWhite};
        }
      }

      button {
        text-transform: uppercase;

        &:not(:first-child) {
          margin-left: 15px;
        }
      }
    `
  )}

  /* Figma's buttons hug their label and are sentence-case, so the pinned width and the uppercase go.
     What replaces the legacy sibling margins depends on the layout: the isInline variant is
     inline-block, where gap does nothing, so there the siblings are spaced directly. */
  ${(props: { theme: Env0Theme; isInline?: boolean }) =>
    newDesignOnly(theme =>
      props.isInline
        ? css`
            > * + * {
              margin-inline-start: ${theme.spacing.md};
            }
          `
        : css`
            gap: ${theme.spacing.md};
          `
    )(props)}
`;

export default FormButtonsContainer;
